"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventListeners = getEventListeners;
var safeGet_1 = __importDefault(require("licia/safeGet"));
var isEl_1 = __importDefault(require("licia/isEl"));
var isFn_1 = __importDefault(require("licia/isFn"));
var isBool_1 = __importDefault(require("licia/isBool"));
var keys_1 = __importDefault(require("licia/keys"));
var each_1 = __importDefault(require("licia/each"));
var defaults_1 = __importDefault(require("licia/defaults"));
var isObj_1 = __importDefault(require("licia/isObj"));
var objManager = __importStar(require("../lib/objManager"));
function getEventListeners(params) {
    var obj = objManager.getObj(params.objectId);
    var events = obj.chobitsuEvents || [];
    var listeners = [];
    (0, each_1.default)(events, function (events, type) {
        (0, each_1.default)(events, function (event) {
            listeners.push({
                type: type,
                useCapture: event.useCapture,
                handler: objManager.wrap(event.listener),
                passive: event.passive,
                once: event.once,
                scriptId: '1',
                columnNumber: 0,
                lineNumber: 0,
            });
        });
    });
    return {
        listeners: listeners,
    };
}
var getWinEventProto = function () {
    return (0, safeGet_1.default)(window, 'EventTarget.prototype') || window.Node.prototype;
};
var winEventProto = getWinEventProto();
var origAddEvent = winEventProto.addEventListener;
var origRmEvent = winEventProto.removeEventListener;
winEventProto.addEventListener = function (type, listener, options) {
    addEvent(this, type, listener, options);
    origAddEvent.apply(this, arguments);
};
winEventProto.removeEventListener = function (type, listener) {
    rmEvent(this, type, listener);
    origRmEvent.apply(this, arguments);
};
function addEvent(el, type, listener, options) {
    if (options === void 0) { options = false; }
    if (!(0, isEl_1.default)(el) || !(0, isFn_1.default)(listener))
        return;
    if ((0, isBool_1.default)(options)) {
        options = {
            capture: options,
        };
    }
    else if (!(0, isObj_1.default)(options)) {
        options = {};
    }
    (0, defaults_1.default)(options, {
        capture: false,
        passive: false,
        once: false,
    });
    var events = (el.chobitsuEvents = el.chobitsuEvents || {});
    events[type] = events[type] || [];
    events[type].push({
        listener: listener,
        useCapture: options.capture,
        passive: options.passive,
        once: options.once,
    });
}
function rmEvent(el, type, listener) {
    if (!(0, isEl_1.default)(el) || !(0, isFn_1.default)(listener))
        return;
    var events = el.chobitsuEvents;
    if (!(events && events[type]))
        return;
    var listeners = events[type];
    for (var i = 0, len = listeners.length; i < len; i++) {
        if (listeners[i].listener === listener) {
            listeners.splice(i, 1);
            break;
        }
    }
    if (listeners.length === 0)
        delete events[type];
    if ((0, keys_1.default)(events).length === 0)
        delete el.chobitsuEvents;
}
